<div class="snack-bar-template {{type}}">
  <span matSnackBarLabel class="label">
    <img ngSrc="/assets/images/icons/check-circle.svg" alt="Icon check circle" height="24" width="24"
         *ngIf="type === 'create' || type === 'update'">
    <img ngSrc="/assets/images/icons/error/trash.svg" alt="Icon trash" height="24" width="24" *ngIf="type === 'delete'">
    <img ngSrc="/assets/images/icons/error/error.svg" alt="Icon error" height="24" width="24"
         *ngIf="type === 'user-server-error' || type === 'admin-server-error' || type === 'error'">
    <div class="snack-bar-content {{type}}" >
      {{ content }}
      <ng-container *ngIf="type === 'user-server-error'">
        Essayez de <span (click)="refreshPage()">réactualiser cette page</span> ou n'hésitez pas à <span
        (click)="navigateToContact()"> nous contacter </span> si le problème persiste.
      </ng-container>
       <ng-container *ngIf="type === 'admin-server-error'">
        Essayez de <span (click)="refreshPage()">réactualiser cette page</span>.
      </ng-container>
    </div>
  </span>
  <button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    <img ngSrc="/assets/images/icons/cross.svg" alt="Icon cross" (click)="snackBarRef.dismissWithAction()" height="24" width="24">
  </button>
</div>
